<template>
    <v-layout>
        <v-flex>
            <v-card>   
                <v-card-title >
                    Ledger Creation
                </v-card-title>
                <v-card-text>
                    <v-form>
                    <v-text-field label="Name" ></v-text-field>
                    <v-autocomplete
                    :items='head'>
                    </v-autocomplete>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="success"><v-icon left>save</v-icon>Save</v-btn>
                </v-card-actions>
            </v-card>    
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    computed: {
        head() {
            return this.$store.state.head
        }
    }

}
</script>

<style>

</style>
